import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { FaMedal, FaStamp } from "react-icons/fa";
import {
  MdCollectionsBookmark,
  MdManageAccounts,
  MdOutlineMoreVert,
  MdRememberMe,
} from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import Mainslide from "../components/Mainslide";
import QuickLinkModal from "../components/QuickLinkModal";
import SlickSlider from "../components/SlickSlider";
import "./Main.scss";
// import useEnhancedEffect from "@mui/material/utils/useEnhancedEffect";
import jwtDecode from "jwt-decode";
import Swal from "sweetalert2";
import LogoutModal from "../components/LogoutModal";
function Main() {
  let navigate = useNavigate();
  const token = window.sessionStorage.getItem("token");

  // 공지 공고 고시
  const [cont1, setCont1] = useState("official1");
  // const [showModal, setShowModal] = useState(true);
  // const closeModal = () => {
  //   setShowModal(false);
  // };
  // 모달 상태관리
  const [commServiceModal, setCommServiceModal] = useState(false);
  const [certifiServiceModal, setCertifiServiceModal] = useState(false);
  const [admitServiceModal, setAdmitServiceModal] = useState(false);
  const [testServiceModal, setTestServiceModal] = useState(false);
  const [civilianServiceModal, setCivilianServiceModal] = useState(false);

  // 인증, 인정, 시험, 민간지원, 위원회 메뉴 Response Data
  const [menuData, setMenuData] = useState([]);
  const [menuData1, setMenuData1] = useState([]);
  const [menuData2, setMenuData2] = useState([]);
  const [menuData3, setMenuData3] = useState([]);
  const [commMenuData, setCommMenuData] = useState([]);

  const goCertPage = (taskGroups) => () => {
    const targetId = taskGroups.filter((e) => e.type === 1);
    navigate(`/certified/${targetId[0].id}`, { state: { id: targetId } });
  };

  // 인증, 인정, 시험, 민간지원 서비스 모달내 게시판 출력
  const getMenuData = async () => {
    try {
      const response = await axios.get("/api/workflow", {
        params: { category: 0 },
      });
      setMenuData(response.data.data);
      const response1 = await axios.get("/api/workflow", {
        params: { category: 1 },
      });
      setMenuData1(response1.data.data);

      const response2 = await axios.get("/api/workflow", {
        params: { category: 2 },
      });
      setMenuData2(response2.data.data);

      const response3 = await axios.get("/api/workflow", {
        params: { category: 3 },
      });
      setMenuData3(response3.data.data);
      // console.log(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  // 위원회서비스 모달내 게시판 출력
  const getCommitteeMenu = async () => {
    let commpage = window.sessionStorage.getItem("commpage");
    try {
      if (commpage === null) {
        const response = await axios.get("/api/committee-type");
        window.sessionStorage.setItem(
          "commpage",
          JSON.stringify(response.data.data)
        );
        // commpage = commpage.filter((el) => el.state === 1);
        commpage = JSON.stringify(response.data.data);
      }
      setCommMenuData(JSON.parse(commpage).filter((el) => el.state === 1));
    } catch (error) {
      console.log(error);
    }
  };

  // 인증 인정 시험 민간지원 기준
  const [cont2, setCont2] = useState("standard1");

  let content1 = null;
  if (cont1 === "Notice1") {
    content1 = <Notice1 />;
  } else if (cont1 === "refRoom1") {
    content1 = <RefRoom1 />;
  } else if (cont1 === "official1") {
    content1 = <Official1 />;
  }
  const heighL1 = useRef();
  const btnWidth1 = useRef();
  useEffect(() => {
    heighL1.current.style.width = btnWidth1.current.offsetWidth + "px";
    heighL1.current.style.height = btnWidth1.current.offsetHeight + "px";
  });

  // 퀵메뉴 모달 핸들러
  // 인증서비스
  const openCertifiServiceModal = (e) => {
    e.preventDefault();
    if (menuData.length === 1) {
      const targetId = menuData[0].taskGroups.filter((e) => e.type === 1);
      navigate(`/certified/${targetId[0].id}`, { state: { id: targetId } });
    } else {
      setCertifiServiceModal(true);
    }
  };
  const closeCertifiServiceModal = (e) => {
    e.preventDefault();
    setCertifiServiceModal(false);
  };
  // 인정서비스
  const openAdmitServiceModal = (e) => {
    e.preventDefault();
    if (menuData1.length === 1) {
      const targetId = menuData1[0].taskGroups.filter((e) => e.type === 1);
      navigate(`/certified/${targetId[0].id}`, { state: { id: targetId } });
    } else {
      setAdmitServiceModal(true);
    }
  };
  const closeAdmitServiceModal = (e) => {
    e.preventDefault();
    setAdmitServiceModal(false);
  };
  // 시험서비스
  const openTestServiceModal = (e) => {
    e.preventDefault();
    if (menuData2.length === 1) {
      const targetId = menuData2[0].taskGroups.filter((e) => e.type === 1);
      navigate(`/certified/${targetId[0].id}`, { state: { id: targetId } });
    } else {
      setTestServiceModal(true);
    }
  };
  const closeTestServiceModal = (e) => {
    e.preventDefault();
    setTestServiceModal(false);
  };
  // 민간지원서비스
  const openCivilianServiceModal = (e) => {
    e.preventDefault();
    if (menuData3.length === 1) {
      const targetId = menuData3[0].taskGroups.filter((e) => e.type === 1);
      navigate(`/certified/${targetId[0].id}`, { state: { id: targetId } });
    } else {
      setCivilianServiceModal(true);
    }
  };
  const closeCivilianServiceModal = (e) => {
    e.preventDefault();
    setCivilianServiceModal(false);
  };
  // 위원회서비스
  const openCommServiceModal = (e) => {
    e.preventDefault();
    setCommServiceModal(true);
  };
  const closeCommServiceModal = (e) => {
    e.preventDefault();
    setCommServiceModal(false);
  };
  const commServiceLoginBtn = (e) => {
    e.preventDefault();
    navigate("/login/committee");
  };
  const commServiceLogoutBtn = (e) => {
    e.preventDefault();
    navigate("/Logout");
  };

  function slidingL() {
    heighL1.current.style.left = btnWidth1.current.offsetWidth + "px";
  }
  function slidingL2() {
    heighL1.current.style.left = 0 + "px";
  }
  function slidingL3() {
    heighL1.current.style.left = btnWidth1.current.offsetWidth * 2 + "px";
  }
  // 인증 인정 시험기준
  const [cont, setCont] = useState("official");

  // let content = null;
  // if (cont === "Notice") {
  //   content = <Notice />;
  // } else if (cont === "refRoom") {
  //   content = <RefRoom />;
  // } else if (cont === "official") {
  //   content = <Official />;
  // }
  const heighL = useRef();
  const btnWidth = useRef();
  useEffect(() => {
    heighL.current.style.width = btnWidth.current.offsetWidth + "px";
    heighL.current.style.height = btnWidth.current.offsetHeight + "px";
  });

  function sliding() {
    heighL.current.style.left = btnWidth.current.offsetWidth + "px";
  }
  function sliding2() {
    heighL.current.style.left = 0 + "px";
  }
  function sliding3() {
    heighL.current.style.left = btnWidth.current.offsetWidth * 2 + "px";
  }
  function sliding4() {
    heighL.current.style.left = btnWidth.current.offsetWidth * 3 + "px";
  }
  const [standardData, setStandardData] = useState([]);
  useEffect(() => {
    standardOne();
  }, []);
  const Standard = (category) => {
    axios
      .get("/api/examguide", {
        params: {
          category: category,
          pageSize: 5,
          pageNumber: 1,
        },
      })
      .then((response) => {
        setStandardData(response.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const standardOne = () => {
    sliding2();
    Standard(0);
  };
  const standardTwo = () => {
    sliding();
    Standard(1);
  };
  const standardThree = () => {
    sliding3();
    Standard(2);
  };
  const standardFour = () => {
    sliding4();
    Standard(3);
  };
  //   return (

  //   );
  // };

  useEffect(() => {
    getCommitteeMenu();
    getMenuData();
  }, []);

  const commQuick = (value) => () => {
    let commpage = window.sessionStorage.getItem("commpage");
    let decodedToken = jwtDecode(window.sessionStorage.getItem("token"));
    let filteredData = JSON.parse(commpage).filter((el) =>
      decodedToken.obj?.commTypes?.includes(el.id)
    );
    if (filteredData.filter((el) => el.id === value).length > 0) {
      navigate(`/committeeprocess/${value}`);
    } else {
      Swal.fire({
        icon: "error",
        title: "오류",
        html: "소속된 위원회만 접근가능합니다",
        confirmButtonColor: "dodgerBlue",
      });
    }
  };

  const CommonStandard = () => {
    return (
      <>
        <table className="table_wrap">
          <thead>
            <tr style={{ hover: "none !important" }}>
              <th>글제목</th>
              <th>작성일</th>
            </tr>
          </thead>
          <tbody>
            {standardData.map((bbsInfo) => {
              return (
                <tr className="tr_hover" key={bbsInfo.id}>
                  <td className="bbs_title">
                    <Link
                      to={`/standard/${bbsInfo.id}`}
                      state={{ category: bbsInfo.category }}
                    >
                      {bbsInfo.name}
                    </Link>
                  </td>
                  <td>
                    <Link to={`/standard/${bbsInfo.id}`}>
                      {bbsInfo.updateAt.substring(0, 11).replace(/-/g, ".")}
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {standardData.length > 0 ? null : (
          <p style={{ textAlign: "center", marginTop: "10vh" }}>
            등록된 목록이 없습니다
          </p>
        )}
      </>
    );
  };
  return (
    <>
      {/* { showModal && (
        <div className="popup_bg_bbs " onClick={closeModal}>
          <div
            className="password_change "
            style={{ width: "50vw" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="pophead_bbs">
              <h1>시스템 점검 공지</h1>
            </div>
            <div className="password_change_inner">
              시험인증지원시스템 기능점검으로 인해 아래 기간동안 홈페이지 로그인
              및 로그인 관련 기능 사용이 불가하오니 이점 참고하여 주시기
              바랍니다. <br />
              이용 관련 문의가 있으신 경우, 아래 연락처로 문의 바람니다.
              <br />
              (정기점검기간) '24.11.11., 09:00 ~ '24.11.14., 09:00
              <br />
              (점검 담당자) 새솔테크 유버들 책임 Tel. 010-8923-3925 e-mail.
              bdyu@ssoltech.io <br />
              (시스템 담당자) ITS Korea 이홍범 과장 Tel. 031-478-0453 e-mail.
              honboom@itskorea.kr
              <br />
              <div
                className="btns_wrap"
                style={{ width: "50px", float: "right" }}
              >
                <button className="btn_confirm" onClick={closeModal}>
                  <span className="material-icons">확인</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}  */}

      <div className="content_bg">
        <div className="content_main">
          <div className="row contain">
            <div className="col">
              <section className="poster">
                <Mainslide />
              </section>
            </div>
          </div>

          <div className="row contain">
            <div className="col contents">
              <section className="board">
                <div className="bbs_btns_wrap_bar">
                  <div className="bbs_btns_wrap">
                    <button
                      className="btnWidth"
                      ref={btnWidth1}
                      onClick={() => {
                        slidingL2();
                        setCont1("official1");
                      }}
                    >
                      공지
                    </button>
                    <button
                      className="btnWidth"
                      ref={btnWidth1}
                      onClick={() => {
                        slidingL();
                        setCont1("Notice1");
                      }}
                    >
                      공고
                    </button>
                    <button
                      className="btnWidth"
                      ref={btnWidth1}
                      onClick={() => {
                        slidingL3();
                        setCont1("refRoom1");
                      }}
                    >
                      고시
                    </button>
                  </div>
                  <span className="heighL" ref={heighL1}></span>

                  {/* 공지 */}
                  {cont1 === "official1" && (
                    <Link to="notice">
                      <span className="material-icons mor_btn_dot">
                        <MdOutlineMoreVert />
                      </span>
                    </Link>
                  )}

                  {/* 고시 */}
                  {cont1 === "refRoom1" && (
                    <Link to="disclosure">
                      <span className="material-icons mor_btn_dot">
                        <MdOutlineMoreVert />
                      </span>
                    </Link>
                  )}

                  {/* 공고 */}
                  {cont1 === "Notice1" && (
                    <Link to="announcement">
                      <span className="material-icons mor_btn_dot">
                        <MdOutlineMoreVert />
                      </span>
                    </Link>
                  )}
                </div>
                {content1}
              </section>
            </div>
            <div className="col contents">
              <section className="board">
                <div className="bbs_btns_wrap_bar">
                  <div className="bbs_btns_wrap">
                    <button
                      className="btnWidth"
                      ref={btnWidth}
                      onClick={() => {
                        standardOne();
                        setCont2("standard1");
                      }}
                    >
                      인증기준
                    </button>
                    <button
                      className="btnWidth"
                      ref={btnWidth}
                      onClick={() => {
                        standardTwo();
                        setCont2("standard2");
                      }}
                    >
                      인정기준
                    </button>
                    <button
                      className="btnWidth"
                      ref={btnWidth}
                      onClick={() => {
                        standardThree();
                        setCont2("standard3");
                      }}
                    >
                      시험기준
                    </button>
                    <button
                      className="btnWidth"
                      ref={btnWidth}
                      onClick={() => {
                        standardFour();
                        setCont2("standard4");
                      }}
                    >
                      민간지원기준
                    </button>
                  </div>
                  <span className="heighL" ref={heighL}></span>

                  {/* 인증기준 */}
                  {cont2 === "standard1" && (
                    <Link to="standard" state={{ category: 0 }}>
                      <span className="material-icons mor_btn_dot">
                        <MdOutlineMoreVert />
                      </span>
                    </Link>
                  )}

                  {/* 인정기준 */}
                  {cont2 === "standard2" && (
                    <Link to="standard" state={{ category: 1 }}>
                      <span className="material-icons mor_btn_dot">
                        <MdOutlineMoreVert />
                      </span>
                    </Link>
                  )}

                  {/* 시험기준 */}
                  {cont2 === "standard3" && (
                    <Link to="standard" state={{ category: 2 }}>
                      <span className="material-icons mor_btn_dot">
                        <MdOutlineMoreVert />
                      </span>
                    </Link>
                  )}

                  {/* 민간지원기준 */}
                  {cont2 === "standard4" && (
                    <Link to="standard" state={{ category: 3 }}>
                      <span className="material-icons mor_btn_dot">
                        <MdOutlineMoreVert />
                      </span>
                    </Link>
                  )}
                </div>
                <CommonStandard />
              </section>
            </div>
          </div>
        </div>
        <aside className="aside_menu">
          <div className="service_btn" onClick={openCertifiServiceModal}>
            {certifiServiceModal ? (
              <QuickLinkModal
                closeModal={closeCertifiServiceModal}
                modalTitle={"인증 서비스 바로가기"}
                content={menuData.map((e) => (
                  <li
                    className="lnb quick_menu_btn_gray"
                    onClick={goCertPage(e.taskGroups)}
                  >
                    <a style={{ cursor: "pointer" }}>{e.name}</a>
                  </li>
                ))}
              />
            ) : null}
            <FaMedal />
            <p>인증서비스</p>
          </div>
          <div className="service_btn" onClick={openAdmitServiceModal}>
            {admitServiceModal ? (
              <QuickLinkModal
                closeModal={closeAdmitServiceModal}
                modalTitle={"인정 서비스 바로가기"}
                content={menuData1.map((e) => (
                  <li
                    className="lnb quick_menu_btn_gray"
                    onClick={goCertPage(e.taskGroups)}
                  >
                    <a style={{ cursor: "pointer" }}>{e.name}</a>
                  </li>
                ))}
              />
            ) : null}
            <FaStamp />
            <p>인정서비스</p>
          </div>
          <div className="service_btn" onClick={openTestServiceModal}>
            {testServiceModal ? (
              <QuickLinkModal
                closeModal={closeTestServiceModal}
                modalTitle={"시험 서비스 바로가기"}
                content={menuData2.map((e) => (
                  <li
                    className="lnb quick_menu_btn_gray"
                    onClick={goCertPage(e.taskGroups)}
                  >
                    <a style={{ cursor: "pointer" }}>{e.name}</a>
                  </li>
                ))}
              />
            ) : null}
            <MdCollectionsBookmark />
            <p>시험서비스</p>
          </div>
          <div className="service_btn" onClick={openCivilianServiceModal}>
            {civilianServiceModal ? (
              <QuickLinkModal
                closeModal={closeCivilianServiceModal}
                modalTitle={"민간지원 서비스 바로가기"}
                content={menuData3.map((e) => (
                  <li
                    className="lnb quick_menu_btn_gray"
                    onClick={goCertPage(e.taskGroups)}
                  >
                    <a style={{ cursor: "pointer" }}>{e.name}</a>
                  </li>
                ))}
              />
            ) : null}
            <MdManageAccounts />
            <p>민간지원서비스</p>
          </div>
          <div className="service_btn" onClick={openCommServiceModal}>
            {commServiceModal && !token && (
              <LogoutModal
                closeModal={closeCommServiceModal}
                logBtn={commServiceLoginBtn}
                modalTitle={"위원회 전용 서비스"}
                content={"위원회 로그인이 필요합니다."}
                logMsg={"로그인"}
              />
            )}
            {!window.sessionStorage.getItem("committee") &&
              commServiceModal &&
              token && (
                <LogoutModal
                  closeModal={closeCommServiceModal}
                  logBtn={commServiceLogoutBtn}
                  modalTitle={"위원회 전용 서비스"}
                  content={"위원회 로그인이 필요합니다. "}
                  logMsg={"로그아웃"}
                />
              )}
            {window.sessionStorage.getItem("committee") && commServiceModal && (
              <QuickLinkModal
                closeModal={closeCommServiceModal}
                modalTitle={"위원회 서비스 바로가기"}
                content={commMenuData.map((value) => {
                  return (
                    // <li
                    //   className="lnb quick_menu_btn_gray"
                    //   key={value.id}
                    //   onClick={() => {
                    //     navigate(`/committeeprocess/${value.id}`);
                    //   }}
                    // >
                    <li
                      className="lnb quick_menu_btn_gray"
                      key={value.id}
                      onClick={commQuick(value.id)}
                    >
                      <a>{value.name}</a>
                    </li>
                  );
                })}
              />
            )}

            <MdRememberMe />
            <p>위원회서비스</p>
          </div>
          <div className="lava"></div>
        </aside>
      </div>
      <SlickSlider />
    </>
  );
}

// 공지
function Official1() {
  const [officialBbsInfo, setOfficialBbsInfo] = useState([]);

  useEffect(() => {
    axios
      .get("/api/board", {
        params: {
          type: 1,
          pageSize: 5,
          pageNumber: 1,
        },
      })
      .then((response) => {
        setOfficialBbsInfo(response.data.data);
      });
  }, []);

  return (
    <>
      <table className="table_wrap">
        <thead>
          <tr>
            <th>글제목</th>
            <th>작성일</th>
          </tr>
        </thead>
        <tbody>
          {officialBbsInfo.map((bbsInfo) => {
            return (
              // UI 깨짐
              // <Link to={`/notice/${bbsInfo.id}`}>
              //   <tr key={bbsInfo.id}>
              //     <td className="bbs_title">{bbsInfo.title}</td>
              //     <td>{bbsInfo.createAt.substring(0,11).replace(/-/g, ".")}</td>
              //   </tr>
              // </Link>

              <tr className="tr_hover" key={bbsInfo.id}>
                <td className="bbs_title">
                  <Link to={`/notice/${bbsInfo.id}`}>{bbsInfo.title}</Link>
                </td>
                <td>
                  <Link to={`/notice/${bbsInfo.id}`}>
                    {bbsInfo.updateAt?.substring(0, 11).replace(/-/g, ".")}
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {officialBbsInfo.length > 0 ? null : (
        <p style={{ textAlign: "center", marginTop: "10vh" }}>
          등록된 목록이 없습니다
        </p>
      )}
    </>
  );
}

// 공고
function Notice1() {
  const [noticeBbsInfo, setNoticeBbsInfo] = useState([]);

  useEffect(() => {
    axios
      .get("/api/board", {
        params: {
          type: 2,
          pageSize: 5,
          pageNumber: 1,
        },
      })
      .then((response) => {
        setNoticeBbsInfo(response.data.data);
      });
  }, []);

  return (
    <>
      <table className="table_wrap">
        <thead>
          <tr>
            <th>글제목</th>
            <th>작성일</th>
          </tr>
        </thead>
        <tbody>
          {noticeBbsInfo.map((bbsInfo) => {
            return (
              <tr className="tr_hover" key={bbsInfo.id}>
                <td className="bbs_title">
                  <Link to={`/announcement/${bbsInfo.id}`}>
                    {bbsInfo.title}
                  </Link>
                </td>
                <td>
                  <Link to={`/announcement/${bbsInfo.id}`}>
                    {bbsInfo.updateAt?.substring(0, 11).replace(/-/g, ".")}
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {noticeBbsInfo.length > 0 ? null : (
        <p style={{ textAlign: "center", marginTop: "10vh" }}>
          등록된 목록이 없습니다
        </p>
      )}
    </>
  );
}

// 고시
function RefRoom1() {
  const [refRoomBbsInfo, setRefRoomBbsInfo] = useState([]);

  useEffect(() => {
    axios
      .get("/api/board", {
        params: {
          type: 3,
          pageSize: 5,
          pageNumber: 1,
        },
      })
      .then((response) => {
        setRefRoomBbsInfo(response.data.data);
      });
  }, []);

  return (
    <>
      <table className="table_wrap">
        <thead>
          <tr>
            <th>글제목</th>
            <th>작성일</th>
          </tr>
        </thead>
        <tbody>
          {refRoomBbsInfo.map((bbsInfo) => {
            return (
              <tr className="tr_hover" key={bbsInfo.id}>
                <td className="bbs_title">
                  <Link to={`/disclosure/${bbsInfo.id}`}>{bbsInfo.title}</Link>
                </td>
                <td>
                  <Link to={`/disclosure/${bbsInfo.id}`}>
                    {bbsInfo.updateAt?.substring(0, 11).replace(/-/g, ".")}
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {refRoomBbsInfo.length > 0 ? null : (
        <p style={{ textAlign: "center", marginTop: "10vh" }}>
          등록된 목록이 없습니다
        </p>
      )}
    </>
  );
}

export default Main;
